// use this when we want to submit the form on document load
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    $(this.element).autocomplete({
      source: "/gatherers/artists_autocomplete"
    });
  }
}
